import store from "@/store";
import storageObservable from './storageObservable';
import { Client } from './profile';

storageObservable.subscribe<Client>('currentManagerClient', (client) => {
    if (client) store.dispatch('setManagerClientProfileSilent', client)
    else store.dispatch('exitManagerClientSilent')
    /*store.commit('updateManagerClient', {
        ...client
    })*/
}, true)

/*storageObservable.subscribe<Client | Manager>('currentManagerClient', (props) => {
    store.commit('updateProfile', props)
})*/